import type { VoidFunctionComponent } from 'react';

import { useReportLogoSettings } from '../../../../hooks/api/organization/useReportLogoSettings';
import LogoUpload from '../../../LogoUpload';
import Header from '../../../shared/settings/SettingsPageHeader';
import Subheading from '../../../shared/settings/SettingsPageSubheading';
import PageContent from '../shared/SettingsPageContent';

const ProjectReportsSettingsContainer: VoidFunctionComponent = () => {
  const { fileUrl, setFile, unsetFile, handleImgError, onSave, isSaveDisabled, isLoading } = useReportLogoSettings();

  return (
    <PageContent>
      <Header heading="Reports">
        <Header.SaveButton onClick={onSave} isDisabled={isSaveDisabled} isLoading={isLoading} />
      </Header>
      <Subheading>Report Logo</Subheading>
      <LogoUpload fileUrl={fileUrl} setFile={setFile} unsetFile={unsetFile} handleImgError={handleImgError} />
    </PageContent>
  );
};

export default ProjectReportsSettingsContainer;
